import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaintenanceService } from '../../services/maintenance.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, map, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { AccountSplitResource } from 'src/app/client-api.service';
import { AccountSplitService } from '../services/account-splits.service';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';

@Component({
  selector: 'app-account-split-upsert',
  templateUrl: './account-split-upsert.component.html',
  styleUrls: [ './account-split-upsert.component.scss' ]
})
export class AccountSplitUpsertComponent implements OnInit {

  addOrEdit: 'add' | 'edit';
  currentId = 0;
  panalSize: PanelSize = 'large';
  state: 'initializing' | 'loading' | 'ready' | 'saving';  
  currentAccountSplit: AccountSplitResource | undefined;
  accountSplits$ = this.AccountSplitService.accountSplits$;

  accountSplitFormGroup = new FormGroup({
      id: new FormControl(0, { nonNullable: true }),
      name: new FormControl('', { nonNullable: true, validators: Validators.required }),      
      type: new FormControl('', { nonNullable: true, validators: Validators.required }),
      orgCode: new FormControl('', { nonNullable: true }),      
      account: new FormControl('', { nonNullable: true, validators: Validators.required }),      
      percentage: new FormControl(0, { nonNullable: true, validators: Validators.required })      
    });

  constructor( private activatedRoute: ActivatedRoute,
               private maintenanceService: MaintenanceService,
               private AccountSplitService: AccountSplitService,
               private router: Router) { 
    this.addOrEdit = 'edit';
    this.state = 'initializing';
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(routeParam => {
      this.currentId =  routeParam['id'];      
      if(routeParam['id'] !== '0') {
        this.addOrEdit = 'edit';
        this.setCurrentAccountSplit(this.currentId);
      }      
      else {
        this.addOrEdit = 'add';
        this.state = 'ready';       
      }
    });    
  }

  close() {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
  }

  isChanged(field: string) {
    return this.accountSplitFormGroup.get(field)?.dirty;
  }

  setCurrentAccountSplit(id: number): void {
    this.accountSplits$.pipe(
          map((split) => {
            return split.find(o => o.id === parseInt(id.toString(), 10));
          }),      
          tap(split => {
            this.currentAccountSplit = split;
            this.accountSplitFormGroup.patchValue({
                  id: split!.id,
                  name: split!.name,
                  type: split!.type,
                  orgCode: split!.orgCode,
                  account: split!.account,
                  percentage: split!.percentage
                });
            this.state = 'ready';
          }),
          catchError((err) => {
            alert('Error setting the current Management Fee Split!');
            console.log(err);
            return EMPTY; 
          })
        ).subscribe();
  }

  onSubmit() {
      const managementFeesAccountSplitsResource: AccountSplitResource = {
        ...this.accountSplitFormGroup.getRawValue(),
        id: (this.addOrEdit == 'add') ? 0 : this.accountSplitFormGroup.controls.id.value
      };
      
      this.AccountSplitService.putAccountSplit(managementFeesAccountSplitsResource).subscribe(
        res => {
          this.AccountSplitService.setAccountSplits();
          this.close();
        },
        err => {
          console.log(err);
          alert('Error setting AccountSplits!');
        });
    }
}
